import {type ReactNode, useEffect} from 'react';
import {AnimatePresence, usePresence, useReducedMotion} from 'motion/react';

/** Визуальный кадр закрытия. Сохраняет JSX, а не выбранные ID, права или API-данные. */
const PresenceFrame = ({children}: {children: ReactNode}) => {
  const [present, remove] = usePresence();
  const reducedMotion = useReducedMotion();
  useEffect(() => {
    if (present) return;
    // animationend — основной путь; таймер страхует отсутствие CSS/скрытую вкладку.
    const timer = setTimeout(() => remove?.(), reducedMotion ? 20 : 250);
    return () => clearTimeout(timer);
  }, [present, remove, reducedMotion]);
  return (
    <div
      className='modal-presence contents'
      data-state={present ? 'open' : 'closed'}
      inert={!present}
      aria-hidden={!present || undefined}
      onAnimationEnd={(event) => {
        if (!present && event.animationName.startsWith('colver-modal-'))
          remove?.();
      }}
    >
      {children}
    </div>
  );
};

/** Анимация готовой оболочки без задержки закрытия формы, сброса ID или запросов. */
export const ModalPresence = ({children}: {children: ReactNode}) => (
  <AnimatePresence>
    {children && <PresenceFrame key='window'>{children}</PresenceFrame>}
  </AnimatePresence>
);
